import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

const Loading = () => {
    return (
        <Container className="loading-spinner">
            <Spinner animation="border" role="status" variant="primary">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
            <div className="mt-3 text-muted">Loading...</div>
        </Container>
    );
}

export default Loading;
